// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */

.Modal__overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  flex-direction: column;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: rgba(40, 40, 40, 0.6);
  flex-grow: 0px;
  flex-shrink: 1px;
  z-index: 100;
}
.Modal__modal {
  padding: 20px;
  min-height: 100px;
  min-width: 300px;
  display: flex;
  flex-grow: 0px;
  background-color: #fff;
  flex-direction: column;
  position: relative;
  box-shadow: 0 0 20px 0 #444;
  border-radius: 10px;
}
.Modal__title {
  color: #444;
  margin: 0px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
.Modal__closeButton {
  border: 0px;
  position: absolute;
  right: 20px;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 30px;
  height: 30px;
  text-align: center;
  cursor: pointer;
  background-color: #eee;
}
.Modal__closeButton:hover {
  background-color: #ddd;
}
.Modal__content {
  padding-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/lexical-plugins/Modal.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,UAAU;EACV,uCAAuC;EACvC,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB","sourcesContent":["/**\n * Copyright (c) Meta Platforms, Inc. and affiliates.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE file in the root directory of this source tree.\n *\n *\n */\n\n.Modal__overlay {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  flex-direction: column;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  background-color: rgba(40, 40, 40, 0.6);\n  flex-grow: 0px;\n  flex-shrink: 1px;\n  z-index: 100;\n}\n.Modal__modal {\n  padding: 20px;\n  min-height: 100px;\n  min-width: 300px;\n  display: flex;\n  flex-grow: 0px;\n  background-color: #fff;\n  flex-direction: column;\n  position: relative;\n  box-shadow: 0 0 20px 0 #444;\n  border-radius: 10px;\n}\n.Modal__title {\n  color: #444;\n  margin: 0px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #ccc;\n}\n.Modal__closeButton {\n  border: 0px;\n  position: absolute;\n  right: 20px;\n  border-radius: 20px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  width: 30px;\n  height: 30px;\n  text-align: center;\n  cursor: pointer;\n  background-color: #eee;\n}\n.Modal__closeButton:hover {\n  background-color: #ddd;\n}\n.Modal__content {\n  padding-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
